import { Stack, Typography } from '@mui/material';
import { memo } from 'react';

import { VpOtpCode } from '@vp/common/ui/component/VpOtpCode';

export type AccessManagerCodeProps = {
  code: string;
  disabled: boolean;
  onChange: (value: string) => void;
};

export const AccessManagerCode = memo<AccessManagerCodeProps>(({ code, disabled, onChange }) => {
  return (
    <Stack gap={0.75} px={{ mobile: 3, tablet: 7 }}>
      <Typography variant="formLabelMedium" color="text.primary">
        Код доступа
      </Typography>

      <VpOtpCode disabled={disabled} value={code} onChange={onChange} />
    </Stack>
  );
});

AccessManagerCode.displayName = 'AccessManagerCode';
